import { render, staticRenderFns } from "./modal-order-remark.vue?vue&type=template&id=74c7c9d6&scoped=true&"
import script from "./modal-order-remark.vue?vue&type=script&lang=js&"
export * from "./modal-order-remark.vue?vue&type=script&lang=js&"
import style0 from "./modal-order-remark.vue?vue&type=style&index=0&id=74c7c9d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c7c9d6",
  null
  
)

export default component.exports